module.exports = __webpack_public_path__ + "static/media/MyEarnings.24b86907.svg";